import { User } from "./index";

export class ReportShare {
  ID: string;
  USER: User;
  static parse(json: any): ReportShare {
    if (json) {
      const rs = new ReportShare();
      rs.ID = json.ID;

      if (json.USER)
        rs.USER = User.parse(json.USER);

      return rs;
    } else { return null; }
  }

  static parseArray(json: Array<any>): Array<ReportShare> {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(ReportShare.parse(j));

    return arr;
  }
}
